var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 279,
    viewBox: "0 0 424 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.219 278.426H140.497L134.907 243.082H84.2352L78.1041 278.426H0.382812L67.2844 0H159.252L218.219 278.426ZM126.071 183.393L121.202 150.934C121.082 150.814 120.842 149.191 120.481 146.065C120.241 143.421 118.978 132.962 116.694 114.688C116.454 112.645 116.153 109.88 115.793 106.393C115.432 102.787 114.951 98.2786 114.35 92.8688L112.006 66.5409C111.765 69.0655 111.405 71.8907 110.924 75.0163C110.563 78.142 110.142 81.5682 109.661 85.295C108.82 92.7486 108.219 97.918 107.858 100.803C107.497 103.688 107.257 105.432 107.137 106.033L101.907 139.754L94.3336 183.393H126.071Z",
    fill: "#FDBB11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M423.446 278.426H342.118L304.971 179.246C304.61 177.563 303.949 175.339 302.987 172.574C302.146 169.809 301.064 166.503 299.741 162.656L300.282 181.049V278.426H225.446V0H302.446C336.348 0 361.714 6.67213 378.545 20.0164C399.943 37.0874 410.643 61.3715 410.643 92.8688C410.643 126.53 396.277 149.792 367.545 162.656L423.446 278.426ZM300.643 128.934H305.692C314.348 128.934 321.561 125.628 327.331 119.016C333.102 112.404 335.987 103.989 335.987 93.7704C335.987 72.9726 325.107 62.5737 303.348 62.5737H300.643V128.934Z",
    fill: "#FDBB11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.1adfb3002cf3cd0c102b576d7adffbfd.svg";
export { ForwardRef as ReactComponent };